import modalMedical from './modalMedical.vue'
export default modalMedical
